import React, { useEffect, useState, useMemo } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import { Card, CardBody } from 'reactstrap';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { gAPI_User_SignIn_Logs_Group } from '../../../../../../constants/APIs';

const pageSize = 15;

const SignInLogs = ({ groupId, visible }) => {
  const [logs, setLogs] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async (page) => {
    try {
      debugger;
      setLoading(true);

      const response = await AxiosAPI({
        method: 'get',
        url: gAPI_User_SignIn_Logs_Group,
        params: {
          groupId,
          pageNumber: page,
          pageSize,
        },
      });

      const data = response?.data || {};

      setLogs(data.logs || []);
      setTotalCount(data.totalItems || 0);
    } catch (error) {
      console.error('Error fetching sign-in logs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!visible || !groupId) return;
    setPageNumber(1);
  }, [groupId]);

  useEffect(() => {
    if (!visible || !groupId) return;
    fetchLogs(pageNumber);
  }, [visible, pageNumber, groupId]);

  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  const formattedLogs = useMemo(
    () =>
      logs.map((log) => ({
        userName: log.userName || '-',
        email: log.email || '-',
        property: log.propertyName || log.propertyId || '-',
        loginTime: log.signedInUtc
          ? moment.utc(log.signedInUtc).local().format('MMM DD, YYYY hh:mm a')
          : '-',
      })),
    [logs]
  );

  const columns = useMemo(
    () => [
      { Header: 'User Name', accessor: 'userName' },
      { Header: 'Email', accessor: 'email' },
      { Header: 'Property', accessor: 'property' },
      { Header: 'Login Time', accessor: 'loginTime' },
    ],
    []
  );
  return (
    <Card className="mb-2">
      <CardBody>
        {
          <ReactTable
            data={formattedLogs}
            columns={columns}
            pages={totalPages}
            page={pageNumber - 1}
            manual
            loading={loading}
            defaultPageSize={pageSize}
            className="-striped -highlight"
            showPageJump={true}
            showPageSizeOptions={false}
            PaginationComponent={(props) => (
              <DataTablePagination
                {...props}
                onPageChange={(page) => {
                  setPageNumber(page + 1);
                }}
              />
            )}
          />
        }
      </CardBody>
    </Card>
  );
};

export default SignInLogs;
